import { type CurrentUser, type CurrentUserIguanaObject } from './types';

export function isCurrentUser(value: CurrentUser | CurrentUserIguanaObject | null | undefined): value is CurrentUser {
    if (!value) return false;
    return !isCurrentUserIguanaObject(value);
}

export function isCurrentUserIguanaObject(
    value: CurrentUser | CurrentUserIguanaObject | null | undefined,
): value is CurrentUserIguanaObject {
    if (!value || typeof value !== 'object') {
        return false;
    }

    return '__iguana_type' in (value as Record<string, unknown>);
}
